import { useState } from "react";
import { Grid } from "@mui/material";

import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Layout } from "ui-components/Layout";
import { FormTitle, SelectFields } from "ui-components/Form";
import { Success, Error_, LoadingDialog } from "ui-components/Alert";
import { useZoneOptionsQuery } from "hooks/useZoneQuery";
import { useLocationOptionsQuery } from "hooks/useLocationQuery";
import { putawayCancelOrderColumns } from "./columns";
import { StyledDataGrid } from "ui-components/data-grids/StripedCheckboxDataGrid";
import { getCancelOrders, getCancelOrder, confirmCancelOrder } from "services/data.inbound.service";
import { useCustomerValue } from "providers/CustomerContext";
import { AddButton, DeleteButton } from "ui-components/IconButton";
import { editPTO } from "services/data.inbound.service";
import { addPTO } from "services/data.inbound.service";
import { deletePTO } from "services/data.inbound.service";

function CancelOrder() {
  const { customerCode } = useCustomerValue();
  //const putawayId = 1;
  const [alert, setAlert] = useState(null);
  const [zoneOptions, setZoneOptions] = useState([]);
  //const [locOptions, setLocOptions] = useState([]);
  const [zoneObj, setZoneObj] = useState({});
  const [zoneID, setZoneID] = useState(null);
  //const [locID, setLocID] = useState(null);
  const [warehouseCode, setWarehouseCode] = useState(null);
  const onSuccess = (data) => setAlert(<Success data={data} onChange={setAlert} />);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  const [orders, setOrders] = useState([]);
  const [order, setOrder] = useState(null);
  const [orderDetails, setOrderDetails] = useState([]);
  const queryClient = useQueryClient();
  const [editing, setEditing] = useState(false);

  const { isFetching } = useQuery({
    queryKey: ["cancel-orders"],
    queryFn: () => getCancelOrders({ customer_code: customerCode }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => setOrders(data.data.data),
    onError,
  });

  const { isFetching: isOrderFetching } = useQuery({
    queryKey: ["cancel-order", { order }],
    queryFn: () => getCancelOrder({ customer_code: customerCode, order_number: order }),
    enabled: Boolean(customerCode) && Boolean(order),
    onSuccess: (data) => {
      const details = data.data.data;
      setOrderDetails(details);
      if (details.length > 0) {
        setWarehouseCode(details[0].warehouse_code);
      }
    },
    onError,
  });

  const confirmPutawayMutation = useMutation(confirmCancelOrder, {});
  useZoneOptionsQuery({
    whCode: warehouseCode,
    zoneType: "storage",
    onSuccess: (data) => setZoneOptions(data.data.data),
  });

  const editMutation = useMutation(editPTO, {
    onError: (data) => {
      setAlert(<Error_ data={data} onChange={setAlert} />);
    },
  });

  const addMutation = useMutation(addPTO, {
    onError: (data) => {
      setAlert(<Error_ data={data} onChange={setAlert} />);
    },
  });

  const deleteMutation = useMutation(deletePTO, {
    onError: (data) => {
      setAlert(<Error_ data={data} onChange={setAlert} />);
    },
  });

  useLocationOptionsQuery({
    whCode: warehouseCode,
    zoneID: zoneID,
    onSuccess: (data) => {
      const { data: locations } = data.data;
      //setLocID(null);
      //setLocOptions(locations);
      if (!zoneObj.hasOwnProperty(zoneID)) {
        setZoneObj({ ...zoneObj, [zoneID]: locations });
      }
    },
  });

  const confirmStatus = confirmPutawayMutation.status === "loading";

  const submit = () => {
    confirmPutawayMutation.mutate(
      { items: orderDetails },
      {
        onSuccess: (data) => {
          queryClient.invalidateQueries(["cancel-orders"]);
          setOrder(null);
          setOrderDetails([]);
          setAlert(<Success data={data} onChange={setAlert} />);
        },
        onError,
      }
    );
  };

  return (
    <Layout lg={12}>
      {alert}
      {(isFetching || isOrderFetching || confirmStatus) && <LoadingDialog />}
      <FormTitle title="Putaway Cancel Order" />
      <MDBox mt={1.625}>
        <Grid container spacing={3}>
          <Grid item xs={3}>
            <SelectFields
              options={orders}
              field={{
                label: "Cust Order Number",
                name: "order",
                value: order,
                errors: {},
                required: true,
              }}
              onChange={(e, option) => setOrder(option)}
            />
          </Grid>

          {/* <Grid item>
            <MDButton variant="gradient" color="info" onClick={apply} disabled={order === null}>
              retrieve
            </MDButton>
          </Grid> */}
        </Grid>
        <MDTypography mt={1.625} mb={2} color="info" variant="h5">
          Datagrid Display
        </MDTypography>
        <StyledDataGrid
          columns={[
            {
              field: "actions",
              type: "actions",
              headerName: "Actions",
              width: 80,
              cellClassName: "actions",
              getActions: ({ row }) => {
                if (row.manual_added) {
                  return [
                    <DeleteButton
                      title="Delete"
                      onClick={() =>
                        deleteMutation.mutate(row, {
                          onSuccess: () =>
                            setOrderDetails(orderDetails.filter((x) => x.id !== row.id)),
                        })
                      }
                    />,
                  ];
                }
                return [
                  <AddButton
                    disabled={!row.can_add}
                    title="Add"
                    onClick={() => {
                      // const index = orderDetails.findIndex((x) => x.id === row.id);
                      // const ts = new Date().getTime();
                      // const update = orderDetails.map((x) => x);
                      // update.splice(index + 1, 0, {
                      //   ...orderDetails.find((x) => x.id === row.id),
                      //   id: row.id + ts.toString(),
                      //   quantity: 0,
                      //   to_zone: null,
                      //   to_location: null,
                      //   cartonID: null,
                      //   newItem: true,
                      // });

                      addMutation.mutateAsync(row, {
                        onSuccess: (data) => {
                          console.log(data.data.data);
                          const latest = data.data.data;
                          const index = orderDetails.findIndex((x) => x.id === row.id);
                          //const ts = new Date().getTime();
                          const update = orderDetails.map((x) => x);
                          update.splice(index + 1, 0, latest);
                          setOrderDetails(update);
                        },
                      });
                    }}
                  />,
                ];
              },
            },
            ...putawayCancelOrderColumns(zoneOptions, zoneObj, setEditing),
          ]}
          rows={orderDetails}
          //onRowSelectionModelChange={(id) => setSelectedIds(id)}
          //rowSelectionModel={selectedIds}
          processRowUpdate={async (updatedRow, originalRow) => {
            setAlert(null);
            setEditing(false)
            if (zoneObj.hasOwnProperty(updatedRow.to_zone)) {
            } else {
              setZoneID(updatedRow.to_zone);
            }
            if (updatedRow.to_zone !== originalRow.to_zone) {
              updatedRow.to_location = null;
            }
            try {
              await editMutation.mutateAsync(updatedRow, {
                onSuccess: () => {
                  setOrderDetails(
                    orderDetails.map((x) => {
                      if (x.id === updatedRow.id) return updatedRow;
                      return x;
                    })
                  );
                },
              });
              return updatedRow;
            } catch (error) {
              return originalRow;
            }
          }}
          onProcessRowUpdateError={(error) => console.log(error)}
          disableRowSelectionOnClick={true}
        />
      </MDBox>

      <MDBox mt={2} width="100%" display="flex" justifyContent="center">
        <MDButton
          variant="gradient"
          color="info"
          onClick={() => submit(false)}
          disabled={orderDetails.length === 0 || editing || confirmStatus}
        >
          Submit
        </MDButton>
      </MDBox>
    </Layout>
  );
}

export default CancelOrder;
